





































































































































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat, isDecimal } from '@/utils/common'
import { MensagensDaApiEnum } from '@/types/_'

@Component

export default class ComponentModalCriarEditarSenioridade extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string

  $refs!: { formItemTabelaPrecoProcedimento: any }

  formItemTabelaPrecoProcedimentoRules: any = {
    valid: true,
    codigoUnico: [(v: string) => !!v || 'Campo obrigatório'],
    descricao: [(v: string) => !!v || 'Campo obrigatório'],
    valorProcedimento: [(v: string) => this.validateValorProcedimento(v)],
    fatorViaUnica: [(v: string) => this.validateOpcionais(v)],
    fatorViaMesma: [(v: string) => this.validateOpcionais(v)],
    fatorViaSeparada: [(v: string) => this.validateOpcionais(v)],
    fatorViaBilateral: [(v: string) => this.validateOpcionais(v)],
  }

  validateValorProcedimento(value: string) {
    if (isDecimal(value)) return 'Formato inválido.'
    return true
  }

  validateOpcionais(value: string) {
    if (!value) return true
    if (isDecimal(value)) return 'Formato inválido.'
    return true
  }

  dicaNumeric: string = 'Use somente números inteiros ou decimais separados por ponto (.)'
  dicaFatores: string = 'Para valores como 30%, por exemplo, escreva 0.3. 150%, escreva 1.5, etc.'

  loadCreateOrUpdateItemTabelaPrecoProcedimento: boolean = false
  get loadingCreateOrUpdateItemTabelaPrecoProcedimento() { return this.loadCreateOrUpdateItemTabelaPrecoProcedimento }
  set loadingCreateOrUpdateItemTabelaPrecoProcedimento(value: boolean) { this.loadCreateOrUpdateItemTabelaPrecoProcedimento = value }

  get modalCriarEditarItemTabelaPrecoProcedimento() { return this.getFinanceiroStore.modal.criarEditarItemTabelaPrecoProcedimento }
  set modalCriarEditarItemTabelaPrecoProcedimento(value: boolean) { this.getFinanceiroStore.setModal({ name: 'criarEditarItemTabelaPrecoProcedimento', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  async createOrUpdateItemTabelaPrecoProcedimento() {
    this.loadingCreateOrUpdateItemTabelaPrecoProcedimento = true

    if (this.$refs.formItemTabelaPrecoProcedimento.validate()) {
      const request = this.mode === 'CREATE'
        ? await this.getFinanceiroStore.createItemsTabelaPrecoProcedimento()
        : await this.getFinanceiroStore.updateItemByTabelaDeReferenciaId()

      if (request.success) {
        if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD && this.mode === 'EDIT') {
          EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
          this.modalCriarEditarItemTabelaPrecoProcedimento = false
          this.loadingCreateOrUpdateItemTabelaPrecoProcedimento = false
          return
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Item ${this.mode === 'CREATE' ? 'criado' : 'atualizado'} com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.$emit('update-items-table', true)
        this.modalCriarEditarItemTabelaPrecoProcedimento = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingCreateOrUpdateItemTabelaPrecoProcedimento = false
  }

  onlyFloatUtil(value) {
    return onlyFloat(value)
  }

  @Watch('modalCriarEditarItemTabelaPrecoProcedimento')
  onChangeModalCriarEditarItemTabelaPrecoProcedimento(value) {
    if (!value) {
      this.getFinanceiroStore.clearItemTabelaPrecoProcedimento()
      this.getFinanceiroStore.clearOriginalItemTabelaPrecoProcedimento()
      this.$refs.formItemTabelaPrecoProcedimento.resetValidation()
    }
  }
}
